import React from "react";
import getGoogleMapsLink from "./../../utilities/maps";

export const linkToGoogleMaps = (tableInfo, event) => {
  if (tableInfo && tableInfo.column) {
    let ubicacion;
    switch (tableInfo.column.id) {
      case "Mapa":
      case "Latitud":
        ubicacion = tableInfo.original;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      default:
        break;
    }
  }
};

export const buildServicesEventsColumns = lang => {
  const servicesEventsColumns = [
    {
      Header: lang.Unidad,
      accessor: "UnidadDescripcion"
    },
    {
      Header: lang.CantidadDeServicios,
      accessor: "CantidadServicios"
    },
    {
      Header: lang.Litros,
      accessor: "LitrosServidos"
    },
    {
      Header: lang.Kilos,
      accessor: "KilosServidos"
    },
    {
      Header: lang.ClientesVisitados,
      accessor: "CantidadClientesVisitados"
    },
    {
      Header: lang.Descuento,
      accessor: "CantidadVentasDescuento"
    },
    {
      Header: lang.Total,
      accessor: "TotalVenta"
    }
  ];

  return servicesEventsColumns;
};

export const buildServicesColumns = lang => {
  const servicesColumns = [
    {
      Header: lang.Cliente,
      accessor: "Cliente"
    },
    {
      Header: lang.Mapa,
      accessor: "Latitud",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {lang.Mapa}
        </span>
      ),
      filterable: false
    },
    {
      Header: lang.Fecha,
      accessor: "Fecha"
    },
    {
      Header: lang.Litros,
      accessor: "LitrosServidos"
    },
    {
      Header: lang.Kilos,
      accessor: "KilosServidos"
    },
    {
      Header: lang.PrecioPorLt,
      accessor: "PrecioLt"
    },
    {
      Header: lang.Descuento,
      accessor: "Descuento"
    },
    {
      Header: lang.Total,
      accessor: "PrecioTotal"
    }
  ];

  return servicesColumns;
};

export const buildClientsColumns = lang => {
  const clientsColumns = [
    {
      Header: lang.Cliente,
      accessor: "Cliente"
    },
    {
      Header: lang.Servicios,
      accessor: "CantidadServicios"
    },
    {
      Header: lang.LitrosDespachados,
      accessor: "LitrosServidos"
    },
    {
      Header: lang.KilosDespachados,
      accessor: "KilosServidos"
    },
    {
      Header: lang.Total,
      accessor: "PrecioTotal"
    }
  ];

  return clientsColumns;
};



// WEBPACK FOOTER //
// ./src/containers/Gas/builders.js